function getRelations(people) {
  var relations = {};
  relations.children = [];
  relations.guardians = [];
  relations.trustees = [];
  relations.spouse = {};
  relations.executor = {};
  relations.coExecutor = {};
  relations.alternativeExecutor = {};
  relations.heirs = [];
  relations.insuranceNominatedBeneficiary = {};
  relations.livingWillDecisionMaker = {};
  relations.willLocationContact = {};
  relations.emergencyContacts = [];
  var createdAtTimes = {};
  createdAtTimes.guardians = {};
  createdAtTimes.trustees = {};
  createdAtTimes.children = {};
  createdAtTimes.heirs = {};
  createdAtTimes.emergencyContacts = {};

  categorizeRelations(people, relations, createdAtTimes);
  sortRelations(relations, createdAtTimes);

  return relations;
}

function categorizeRelations(people, relations, createdAtTimes) {
  for (const person of people) {
    for (const relationship of person.testatorRelationships) {
      if (relationship.relation == 'CHILD_GUARDIAN') {
        createdAtTimes.guardians[person.id] = relationship.createdAt;
        relations.guardians.push(person);
      } else if (relationship.relation == 'CHILD') {
        createdAtTimes.children[person.id] = relationship.createdAt;
        relations.children.push(person);
      } else if (relationship.relation == 'SPOUSE') {
        relations.spouse = person;
      } else if (relationship.relation == 'TRUSTEE') {
        createdAtTimes.trustees[person.id] = relationship.createdAt;
        relations.trustees.push(person);
      } else if (relationship.relation == 'EXECUTOR') {
        relations.executor = person;
      } else if (relationship.relation == 'CO_EXECUTOR') {
        relations.coExecutor = person;
      } else if (relationship.relation == 'ALTERNATIVE_EXECUTOR') {
        relations.alternativeExecutor = person;
      } else if (relationship.relation == 'HEIR') {
        createdAtTimes.heirs[person.id] = relationship.createdAt;
        relations.heirs.push(person);
      } else if (relationship.relation == 'INSURANCE_NOMINATED_BENEFICIARY') {
        relations.insuranceNominatedBeneficiary = person;
      } else if (relationship.relation == 'LIVING_WILL_DECISION_MAKER') {
        relations.livingWillDecisionMaker = person;
      } else if (relationship.relation == 'WILL_LOCATION_CONTACT') {
        relations.willLocationContact = person;
      } else if (relationship.relation == 'EMERGENCY_CONTACT') {
        createdAtTimes.emergencyContacts[person.id] = relationship.createdAt;
        relations.emergencyContacts.push(person);
      }
    }
  }
}

function sortRelations(relations, createdAtTimes) {
  relations.children.sort((a, b) =>
    new Date(createdAtTimes.children[a.id]) >
    new Date(createdAtTimes.children[b.id])
      ? 1
      : -1
  );
  relations.guardians.sort((a, b) =>
    new Date(createdAtTimes.guardians[a.id]) >
    new Date(createdAtTimes.guardians[b.id])
      ? 1
      : -1
  );
  relations.trustees.sort((a, b) =>
    new Date(createdAtTimes.trustees[a.id]) >
    new Date(createdAtTimes.trustees[b.id])
      ? 1
      : -1
  );
  relations.heirs.sort((a, b) =>
    new Date(createdAtTimes.heirs[a.id]) > new Date(createdAtTimes.heirs[b.id])
      ? 1
      : -1
  );
}

function formatKinship(kinship, testator) {
  let kinshipOpt = kinshipOptionsWithChildAndSpouse.find(
    ko => ko['value'] == kinship
  );

  if (!kinshipOpt) {
    return kinship || '';
  }

  if (kinship !== 'SPOUSE') return kinshipOpt['text'];

  // if Spouse
  if (testator.maritalRegime === 'LIFE_PARTNER') return 'Life partner';
  return testator.willCountry == 'ZA' ? 'Spouse' : 'Spouse/Partner';
}

const kinshipOptions = [
  { text: 'Aunt', value: 'AUNT' },
  { text: 'Brother', value: 'BROTHER' },
  { text: 'Brother-in-law', value: 'BROTHER_IN_LAW' },
  { text: 'Cousin', value: 'COUSIN' },
  { text: 'Daughter-in-law', value: 'DAUGHTER_IN_LAW' },
  { text: 'Ex spouse/partner', value: 'EX_SPOUSE' },
  { text: 'Father', value: 'FATHER' },
  { text: 'Father-in-law', value: 'FATHER_IN_LAW' },
  { text: 'Fiancé', value: 'FIANCE' },
  { text: 'Friend', value: 'FRIEND' },
  { text: 'Godfather', value: 'GODFATHER' },
  { text: 'Godmother', value: 'GODMOTHER' },
  { text: 'Goddaughter', value: 'GODDAUGHTER' },
  { text: 'Godson', value: 'GODSON' },
  { text: 'Granddaughter', value: 'GRANDDAUGHTER' },
  { text: 'Grandfather', value: 'GRANDFATHER' },
  { text: 'Grandmother', value: 'GRANDMOTHER' },
  { text: 'Grandson', value: 'GRANDSON' },
  { text: 'Mother', value: 'MOTHER' },
  { text: 'Mother-in-law', value: 'MOTHER_IN_LAW' },
  { text: 'Nephew', value: 'NEPHEW' },
  { text: 'Niece', value: 'NIECE' },
  { text: 'Other', value: 'OTHER' },
  { text: 'Partner', value: 'PARTNER' },
  { text: 'Sister', value: 'SISTER' },
  { text: 'Sister-in-law', value: 'SISTER_IN_LAW' },
  { text: 'Son-in-law', value: 'SON_IN_LAW' },
  { text: 'Stepbrother', value: 'STEPBROTHER' },
  { text: 'Stepdaughter', value: 'STEPDAUGHTER' },
  { text: 'Stepfather', value: 'STEPFATHER' },
  { text: 'Stepmother', value: 'STEPMOTHER' },
  { text: 'Stepsister', value: 'STEPSISTER' },
  { text: 'Stepson', value: 'STEPSON' },
  { text: 'Uncle', value: 'UNCLE' },
];

const kinshipOptionsWithChildAndSpouse = [
  ...[
    { text: 'Child', value: 'CHILD' },
    { text: 'Spouse / Life Partner', value: 'SPOUSE' },
  ],
  ...kinshipOptions,
];

function getAge(dob) {
  var today = new Date();
  var birthDate = new Date(dob);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export {
  getRelations,
  kinshipOptions,
  formatKinship,
  kinshipOptionsWithChildAndSpouse,
  getAge,
};
